import { changetheme } from '@/app/store/layout/layout-action'
import { CommonModule, DOCUMENT } from '@angular/common'
import {
    CUSTOM_ELEMENTS_SCHEMA,
    Component,
    EventEmitter,
    Inject,
    Input,
    Output,
    inject,
    type TemplateRef,
} from '@angular/core'
import {
    NgbDropdownModule,
    NgbOffcanvas,
    NgbOffcanvasModule,
    NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { SimplebarAngularModule } from 'simplebar-angular'
import { getLayoutColor } from '../../store/layout/layout-selector'
import { logout } from '@/app/store/authentication/authentication.actions'
import { Router, RouterLink } from '@angular/router'
import { activityStreamData, appsData } from './data'
import { LocalStorageConstants } from '@/app/core/constants/local-storage'
import { LocalStorageService } from '@/app/helpers/local-storage.service'
import { Subscription } from 'rxjs'
import { DataService } from '@/app/shared/data.service'
import { PrimengThemeService } from '@/app/core/theme/primeng-theme.service'
import { TimeAgoPipe } from '@/app/pipes/timeAgo.pipe'

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    NgbDropdownModule,
    SimplebarAngularModule,
    NgbOffcanvasModule,
    RouterLink,
    CommonModule,
    NgbTooltipModule
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TopbarComponent {
  element: any

  router = inject(Router)
  store = inject(Store)
  offcanvasService = inject(NgbOffcanvas)

  appsList = appsData
  activityList = activityStreamData
  @Output() settingsButtonClicked = new EventEmitter()
  @Output() mobileMenuButtonClicked = new EventEmitter()
  private subscription: Subscription
  private themeSubscription: Subscription
  currentUser: any
  // private lastNotificationUpdate: Date | null = null;

  modeIcons: any = {
    light: 'iconamoon:mode-dark-duotone',
    dark: 'iconamoon:mode-light-duotone',
  }
  currentModeIcon: any

  isFullscreen: boolean = false

  constructor(
    @Inject(DOCUMENT) private document: any,
    private localStorage: LocalStorageService,
    private dataService: DataService,
    private primengThemeService: PrimengThemeService,
  ) {}

  ngOnInit(): void {
    this.element = document.documentElement
    this.getCurrentUser()
    this.getCurrentTheme()

    this.subscription = this.dataService.message$.subscribe((res) => {
      if (
        res.functionName == 'getCurrentUser' &&
        res.toComponent == 'TopbarComponent'
      ) {
        this.getCurrentUser()
      }
    })

    this.themeSubscription = this.store
      .select(getLayoutColor)
      .subscribe((color) => {
        this.currentModeIcon = this.modeIcons[color]
        this.localStorage.set(LocalStorageConstants.theme, color)
        document.documentElement.setAttribute('data-bs-theme', color)
        this.primengThemeService.switchTheme(color as 'light' | 'dark')
      })

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe()
    }
  }

  getCurrentUser() {
    this.currentUser = this.localStorage.get(LocalStorageConstants.currentUser)
  }
  getCurrentTheme() {
    var color = this.localStorage.get(LocalStorageConstants.theme) ?? 'light'
    this.store.dispatch(changetheme({ color: color }))
  }

  settingMenu() {
    this.settingsButtonClicked.emit()
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu() {
    // document.getElementById('topnav-hamburger-icon')?.classList.toggle('open');
    this.mobileMenuButtonClicked.emit()
  }

  // Change Theme
  changeTheme() {
    const color = document.documentElement.getAttribute('data-bs-theme')
    if (color == 'light') {
      this.store.dispatch(changetheme({ color: 'dark' }))
    } else {
      this.store.dispatch(changetheme({ color: 'light' }))
    }
  }

  open(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'border-0 width-auto',
    })
  }

  logout() {
    this.store.dispatch(logout())
  }

  getFileExtensionIcon(file: any) {
    const dotIndex = file.lastIndexOf('.')
    const extension = file.slice(dotIndex + 1)
    if (extension == 'docs') {
      return 'bxs-file-doc'
    } else if (extension == 'zip') {
      return 'bxs-file-archive'
    } else {
      return 'bxl-figma '
    }
  }

  getActivityIcon(type: string) {
    if (type == 'task') {
      return 'iconamoon:folder-check-duotone'
    } else if (type == 'design') {
      return 'iconamoon:check-circle-1-duotone'
    } else {
      return 'iconamoon:certificate-badge-duotone'
    }
  }

  resetBreadCum() {
    // Breadcrumb reset logic can be added here if needed
  }

  toggleFullscreen() {
    if (!this.isFullscreen) {
      const elem = this.document.documentElement
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen()
      }
    }
    this.isFullscreen = !this.isFullscreen
  }


}
